export default function checkIsTicketGroupShownInQuery(ticketGroupReference, query) {
  if (!query.show_ticket_groups) return false;

  const showTicketGroups = query.show_ticket_groups
    .split(',')
    .map(ticketGroup => ticketGroup.trim());

  return showTicketGroups.includes(ticketGroupReference);
}
